import { DesktopDatePicker } from '@mui/x-date-pickers';
import { useTheme } from '@mui/material';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

interface Props {
  disabled?: boolean;
  fromDate: Date | null;
  onFromDateChange: (newValue: Date | null) => void;
  toDate: Date | null;
  onToDateChange: (newValue: Date | null) => void;
}

const DateRange: FC<Props> = ({ disabled, fromDate, onFromDateChange, toDate, onToDateChange }) => {
  const theme = useTheme();
  const { t } = useTranslation();

  return (
    <>
      <DesktopDatePicker
        disabled={disabled}
        label={t('date_from')}
        format="dd.MM.yyyy"
        value={fromDate}
        onChange={onFromDateChange}
        slotProps={{
          textField: {
            size: 'small',
            sx: { my: theme.spacing(1) },
          },
        }}
      />
      <DesktopDatePicker
        disabled={disabled}
        label={t('date_to')}
        format="dd.MM.yyyy"
        value={toDate}
        onChange={onToDateChange}
        slotProps={{
          textField: {
            size: 'small',
            sx: { my: theme.spacing(1) },
          },
        }}
      />
    </>
  );
};

export default DateRange;
